module.exports = __webpack_public_path__ + "static/media/hero-image.9359730a.png";